document.addEventListener("DOMContentLoaded",()=>{

const hub=document.querySelector(".fs-floating-actions");

const main=document.querySelector(".fs-main-btn");

if(!hub || !main) return;

// Toggle menu
main.addEventListener("click",(e)=>{

    e.stopPropagation();

    hub.classList.toggle("active");

});

// Enquiry button
const enquiryBtn=document.getElementById("fsEnquiryBtn");

if(enquiryBtn){

    enquiryBtn.addEventListener("click",(e)=>{

        e.preventDefault();

        hub.classList.remove("active");

        if(window.openPopup){

            window.openPopup();

        }

    });

}

// Close menu after clicking any action
document.querySelectorAll(".fs-action").forEach(btn=>{

    btn.addEventListener("click",()=>{

        hub.classList.remove("active");

    });

});

// Click outside
document.addEventListener("click",(e)=>{

    if(!hub.contains(e.target)){

        hub.classList.remove("active");

    }

});

});


const downloadBtn=document.getElementById("fsDownloadBtn");

downloadBtn.addEventListener("click",()=>{

    hub.classList.remove("active");

    document.getElementById("downloadModal").style.display="flex";

});


document.getElementById("downloadNow").addEventListener("click",()=>{

    const phone=document.getElementById("downloadPhone").value.trim();

    if(phone.length!=10){

        alert("Please enter a valid mobile number");

        return;

    }

    // Future: save phone number here

    window.open(
        "https://cdn.shopify.com/s/files/1/0823/6220/4381/files/FilingSuvidha_Compliance_Calendar_August2026_2Page.pdf?v=1785777364",
        "_blank"
    );

});


const modal = document.getElementById("downloadModal");

document.getElementById("fsDownloadBtn").onclick = () => {

    modal.classList.add("active");

};

document.getElementById("closeDownloadModal").onclick = () => {

    modal.classList.remove("active");

};

window.onclick = function(e){

    if(e.target===modal){

        modal.classList.remove("active");

    }

}

document
.getElementById("downloadCalendarForm")
.addEventListener("submit",function(){

    setTimeout(()=>{

        window.location.href="https://cdn.shopify.com/s/files/1/0823/6220/4381/files/FilingSuvidha_Compliance_Calendar_August2026_2Page.pdf?v=1785777364";

        modal.classList.remove("active");

        const toast=document.getElementById("downloadSuccess");

        toast.classList.add("show");

        setTimeout(()=>{

            toast.classList.remove("show");

        },4000);

    },1200);

});